/**
 * (c) 2009-2024 Clinithink confidential.
 * Please see LICENSE at the project root for details.
 *
 * @file
 * An index into all CDI WebUI utility files
 */
const toastOptions = {
  height: 45,
  width: 300,
  minWidth: 150,
  displayTime: 3500,
  animation: {
    show: {
      type: "fade",
      duration: 400,
      from: 0,
      to: 1,
    },
    hide: { type: "fade", duration: 40, to: 0 },
  },
};

const toastStack = {
  position: "top center",
  direction: "down-push",
};

export { toastOptions, toastStack };
